import React from "react";
import { Table, Space, Select} from "antd";
import "../../Styles/styles-ResultsTable.css";
import { useSelector } from "react-redux";
import { TrainingAPI } from "../../api/TrainingAPI";
import { audioMessage as message } from "../Common/Notifications/audioMessage";

const { Option } = Select;

export function ForceplateAndTestingBreakdownTable({
  type, 
  start_date, 
  end_date, 
  showAll, 
  position_filter,
  stat,
  metric_type="forceplate"}) {
  const { all_metric_types } = useSelector(({ team }) => team);
  const {
    loading: { testingData: loading },
  } = useSelector((store) => store[type]);

  const dropdownMetrics = all_metric_types[metric_type];

  const [metricId, setMetricId] = React.useState(undefined)
  const [inputData, setInputData] = React.useState([])

  React.useEffect(() => {
    if (metricId) getMetricData(metricId)
  }, [start_date, end_date, position_filter, metric_type, metricId, stat]);

  const trainingAPI = new TrainingAPI()

  const getMetricData = (metric_id) => {
    trainingAPI.getFpAndTestingBreakdownTable(start_date, end_date, metric_id, stat, position_filter)
    .then((data) => setInputData(data))
    .catch((err => {
      console.log(err)
      message.error("Error getting metric data")
    }))
  }

  const onMetricChange = (value) => {
    setMetricId(value);
  }

  let all_dates = new Set();
  inputData.map(player_data => {
    all_dates = all_dates.union(new Set(Object.keys(player_data.values)))
  })


  const columns = [
        {
          title: "Player",
          width: 170,
          fixed: "left",
          sorter: {
            compare: (a, b) => (a["first_name"] < b["first_name"] ? -1 : 1),
          },
          render: (_, datapoint,) => {
            return (
              <>
              {datapoint.first_name} {datapoint.last_name}
              </>
            )
          }
        },
        {
          title: "Best",
          dataIndex: "best",
          key: "best",
          width: 100,
          fixed: "left",
          sorter: {
            compare: (a, b) => a["best"] - b["best"],
          },
          render: (_, datapoint,) => {
            return (
              <div style={{
                backgroundColor: "rgba(0, 128, 0, 0.4)",
                padding: "8px",
                margin: "-8px",
                textAlign: "center",
                }}>
                {datapoint.best}
              </div>
            )
          }
        },
        {
          title: "Average",
          dataIndex: "hist_avg",
          key: "hist_avg",
          width: 100,
          fixed: "left",
          sorter: {
            compare: (a, b) => a["hist_avg"] - b["hist_avg"],
          },
        },
      ].concat(
        (Array.from(all_dates) || [])
          .sort((l, r) => (l < r ? -1 : 1))
          .reverse()
          .map((dt, i) => ({
            title: dt.slice(5),
            width: 100,
            sorter: {
              compare: (a, b) => (a.values[dt]?.value || 0) - (b.values[dt]?.value || 0),
            },
            render: (_, datapoint) => {
              const val = datapoint.values[dt]?.value === undefined ? "" : datapoint.values[dt]?.value;
              const hexcolor = datapoint.values[dt]?.color || "#000000";
              const is_best = val === datapoint.best

              return (
                <>
                  <div
                    style={{
                      color: hexcolor,
                      backgroundColor: is_best ? "rgba(0, 128, 0, 0.4)" : "transparent",
                      padding: "8px",
                      margin: "-8px",
                      textAlign: "center",
                    }}
                    key={i}
                  >
                    {val}
                  </div>
                </>
              );
            },
          }))
      )
    

  return (
    <>
      <Space>
        <div className="resultstable-table" >

        <Select
          allowClear
          placeholder="Choose a metric"
          style={{ width: "25rem" }}
          onChange={onMetricChange}
          showSearch
          filterOption={(input, option) =>
            (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
          }
          defaultValue={metricId}
        >
          {dropdownMetrics
            .sort((a, b) => a.name?.localeCompare(b.name))
            .map((item, i) => (
            <Option key={i} value={`${item.metric_type}-${item.metric_id}`}>
              {item.name}
            </Option>
          ))}
        </Select>

          <Table
            className="exportable tab-testing gpsdv-table"
            rowClassName={(row, index) =>
              showAll && "ant-table-row-no-shadow"
            }
            columns={columns}
            size="small"
            dataSource={inputData}
            pagination={
              showAll
                ? false
                : {
                    defaultPageSize: 20,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "30"],
                    position: ["topLeft"],
                  }
            }
            loading={loading}
            scroll={{ x: 0 }}
            style={{ marginTop: 16, maxWidth: "80vw", overflowX: 'auto' }}
          />
        </div>
      </Space>

      {/* <Footer style={{color: 'grey', marginTop:'70px'}}>GPS DataViz 2021</Footer> */}
    </>
  );
}
